import React from 'react';

/**
 * Horizontal status / filter chips. Scrolls on phones instead of wrapping into
 * a tall stack of buttons.
 */
export default function FilterPills({ options = [], value, onChange, className = '' }) {
    return (
        <div className={`flex gap-1 overflow-x-auto overscroll-contain px-2.5 py-2 sm:px-3 ${className}`}>
            {options.map((opt) => {
                const active = value === opt.value;

                return (
                    <button
                        key={opt.value}
                        type="button"
                        onClick={() => onChange(opt.value)}
                        className={`inline-flex shrink-0 items-center gap-1.5 rounded-lg px-2.5 py-1 text-xs font-semibold whitespace-nowrap transition-colors ${
                            active
                                ? 'bg-[#1D2C7B] text-white'
                                : 'bg-slate-50 text-slate-600 hover:bg-slate-100'
                        }`}
                    >
                        {opt.label}
                        {opt.count != null && (
                            <span className={`tabular-nums ${active ? 'text-white/80' : 'text-slate-400'}`}>
                                {opt.count}
                            </span>
                        )}
                    </button>
                );
            })}
        </div>
    );
}
